import { Container } from 'inversify'
import {
  infrastructures,
  rebindAPIConfig,
  clearAPIConfig,
} from './infrastructures.diconfig'
import { repositories } from './repositories.diconfig'
import { usecases } from './usecases.diconfig'

export { TYPES } from '@/libs/di/types'
export const container = new Container()

export const bindAPIToken = (apiToken: APIToken) =>
  rebindAPIConfig(container, apiToken)

export const initializeContainer = (() => {
  // eslint-disable-next-line fp/no-let
  let initialized = false
  const initialize = (apiToken?: APIToken) => {
    container.loadSync(infrastructures, repositories, usecases)
    rebindAPIConfig(container, apiToken)
    initialized = true
  }
  return (apiToken?: APIToken) =>
    initialized ? rebindAPIConfig(container, apiToken) : initialize(apiToken)
})()

export const clearAPIToken = () => clearAPIConfig(container)
